export const TABLE_COL = {
  STT: 'STT',
  PORTFOLIO_NAME: 'portfolioName',
  PROFILE_NAME: 'profileName',
  PORTFOLIO_TRIGGER: 'isTrigger',
}
